import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { getUserName } from '../../../api/Users/user-operations';

const TableNameCell = ({ item, itemList }) => (
  <>
    <td className="align-middle">{isEmpty(item.name) ? getUserName(item) : item.name}</td>
    {!isEmpty(itemList) && <td className="align-middle">{itemList}</td>}
  </>
);

TableNameCell.propTypes = {
  item: PropTypes.object.isRequired,
  itemList: PropTypes.string.isRequired
};

export default TableNameCell;
